<div class="content">
    <div class="row items-push">
      <div class="col-sm-12 text-left">
        <ol class="breadcrumb push-10-t">
          <li><a href="">Configuracion</a></li>
          <li>
            <a
              class="link-effect"
              [routerLink]="['/configuracion', 'maestro-documentos']"
              >Maestro Documentos</a
            >
          </li>
          <li><span class="link-effect">Editar</span></li>
        </ol>
      </div>
    </div>
  </div>
  
  <div class="content">
    <div class="block">
      <div class="block-header">
        <h3 class="block-title">Editar Documento</h3>
      </div>
      <div class="block-content">
        <div class="form-horizontal">

          <form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>

          
          <div class="form-group">
              <label class="col-md-2 control-label">Documento:</label>
              <div class="col-md-3">
                <mat-form-field appearance="outline">
                  <mat-label>Documento</mat-label>
                  <input matInput type="text" [(ngModel)]="model.documento" name="documento" maxlength="100" required />
                </mat-form-field>
              </div>
          </div>

          <div class="form-group">
            <label class="col-md-2 control-label">Estado:</label>
            <div class="col-md-3">
              <mat-form-field appearance="outline">
                <mat-label> Seleccione: </mat-label>
                <mat-select matSelect [(ngModel)]="model.idEstado" name="idEstado" >
                  <mat-option 
                    *ngFor="let item of listaEstados; index as i"
                    [value]="item.idParametroDetalle"
                  >{{ item.valor }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="form-group">
              <div class="col-sm-12">
                <button type="submit" class="btn btn-naranja" [disabled]="modelForm.invalid" mat-raised-button >Guardar</button>
                <a class="btn btn-naranja2" mat-raised-button [routerLink]="['/configuracion', 'maestro-documentos']" >Cancelar</a>                
              </div>
          </div>
        </form>
        </div>
      </div>
    </div>
  </div>
  
  <!-- <pre>{{ model | json}}</pre> -->